import GuarantorsPage from '@/features/applications/[applicationId]/guarantors/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/applications/$applicationId/guarantors/')({
  component: GuarantorsPage,
})
